import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "C:/Projekte/Experimente/github/react-gsap/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Fragment } from 'react';
import { Playground } from 'docz';
import { Controls, PlayState, Tween } from './../../../react-gsap/src/';
import { gsap } from 'gsap';
import { SlowMo } from 'gsap/EasePack';
gsap.registerPlugin(SlowMo);
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h1 {...{
      "id": "easing"
    }}>{`Easing`}</h1>
    <p>{`With GSAP 3 the easing functions are more easily usable as string without importing. They can be used in the "ease" prop of the `}<inlineCode parentName="p">{`Tween`}</inlineCode>{`.`}</p>
    <p>{`Have a look at the docs: `}<a parentName="p" {...{
        "href": "https://greensock.com/docs/v3/Eases"
      }}>{`https://greensock.com/docs/v3/Eases`}</a></p>
    <p>{`The default is `}<inlineCode parentName="p">{`power1.out`}</inlineCode>{`. You can overide the defaults if you want: `}<a parentName="p" {...{
        "href": "https://greensock.com/docs/v3/GSAP/gsap.defaults()"
      }}>{`https://greensock.com/docs/v3/GSAP/gsap.defaults()`}</a>{`.`}</p>
    <pre><code parentName="pre" {...{}}>{`import { Controls, PlayState, Tween } from 'react-gsap';
`}</code></pre>
    <h2 {...{
      "id": "ease-function-with-parameters"
    }}>{`Ease function with parameters`}</h2>
    <Playground __position={0} __code={'<Controls playState={PlayState.stop}>\n  <Tween to={{ x: \'200px\' }} duration={2} ease=\"elastic.out(0.9, 0.1)\">\n    <div style={{ width: \'100px\', height: \'100px\', background: \'#ccc\' }} />\n  </Tween>\n</Controls>'} __scope={{
      props,
      DefaultLayout,
      Fragment,
      Playground,
      Controls,
      PlayState,
      Tween,
      gsap,
      SlowMo,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <Controls playState={PlayState.stop} mdxType="Controls">
    <Tween to={{
          x: '200px'
        }} duration={2} ease="elastic.out(0.9, 0.1)" mdxType="Tween">
      <div style={{
            width: '100px',
            height: '100px',
            background: '#ccc'
          }} />
    </Tween>
  </Controls>
    </Playground>
    <h2 {...{
      "id": "slowmo-ease"
    }}>{`SlowMo ease`}</h2>
    <p>{`This is an extra ease that has to be registered first:`}</p>
    <pre><code parentName="pre" {...{}}>{`import { gsap } from 'gsap';
import { SlowMo } from 'gsap/EasePack';

gsap.registerPlugin(SlowMo);
`}</code></pre>
    <Playground __position={1} __code={'<Controls playState={PlayState.stop}>\n  <Tween to={{ x: \'200px\' }} duration={2} ease=\"slow(0.5, 0.8)\">\n    <div style={{ width: \'100px\', height: \'100px\', background: \'#ccc\' }} />\n  </Tween>\n</Controls>'} __scope={{
      props,
      DefaultLayout,
      Fragment,
      Playground,
      Controls,
      PlayState,
      Tween,
      gsap,
      SlowMo,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <Controls playState={PlayState.stop} mdxType="Controls">
    <Tween to={{
          x: '200px'
        }} duration={2} ease="slow(0.5, 0.8)" mdxType="Tween">
      <div style={{
            width: '100px',
            height: '100px',
            background: '#ccc'
          }} />
    </Tween>
  </Controls>
    </Playground>
    <h2 {...{
      "id": "custom-easing-function"
    }}>{`Custom easing function`}</h2>
    <p>{`You can also pass a function to the ease prop. In this way you can have your custom easing functions.`}</p>
    <p>{`In the example it's an `}<inlineCode parentName="p">{`easeInOutQuart`}</inlineCode>{`. Take a look at this resource for inspiration: `}<a parentName="p" {...{
        "href": "https://easings.net/"
      }}>{`https://easings.net/`}</a></p>
    <Playground __position={2} __code={'<Controls playState={PlayState.stop}>\n  <Tween\n    to={{ x: \'200px\' }}\n    duration={2}\n    ease={x =>\n      x < 0.5 ? 8 * x * x * x * x : 1 - Math.pow(-2 * x + 2, 4) / 2\n    }\n  >\n    <div style={{ width: \'100px\', height: \'100px\', background: \'#ccc\' }} />\n  </Tween>\n</Controls>'} __scope={{
      props,
      DefaultLayout,
      Fragment,
      Playground,
      Controls,
      PlayState,
      Tween,
      gsap,
      SlowMo,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <Controls playState={PlayState.stop} mdxType="Controls">
    <Tween to={{
          x: '200px'
        }} duration={2} ease={x => x < 0.5 ? 8 * x * x * x * x : 1 - Math.pow(-2 * x + 2, 4) / 2} mdxType="Tween">
      <div style={{
            width: '100px',
            height: '100px',
            background: '#ccc'
          }} />
    </Tween>
  </Controls>
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      